import { AreaChart, Area, ResponsiveContainer, Tooltip, YAxis, XAxis } from "recharts";

export function PriceChart({ candles, height = 240, color = "hsl(var(--primary))" }) {
  const data = (candles || []).map((c, i) => ({ i, price: c.c, t: c.t }));
  if (!data.length) return <div className="h-40 flex items-center justify-center text-sm text-muted-foreground">No data</div>;
  const min = Math.min(...data.map((d) => d.price));
  const max = Math.max(...data.map((d) => d.price));
  const pad = (max - min) * 0.1;
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="pc" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.35} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <YAxis domain={[min - pad, max + pad]} hide />
        <XAxis dataKey="i" hide />
        <Tooltip
          contentStyle={{ background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }}
          labelStyle={{ display: "none" }}
          formatter={(v) => [Number(v).toLocaleString(), "Price"]}
        />
        <Area type="monotone" dataKey="price" stroke={color} strokeWidth={2} fill="url(#pc)" />
      </AreaChart>
    </ResponsiveContainer>
  );
}
